<div class="modal-header">
    <button class="btn btn-success" (click)="downloadData();">
        <span *ngIf="!buttonLoader" class="feather icon-download mr-1"></span>
        <span *ngIf="buttonLoader" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
        Download
    </button>
    <h5 class="modal-title font-weight-bold mt-2" id="modal-basic-title">Not Transacting TPN List</h5>
    <button type="button" class="close mt-2" aria-label="Close" (click)="modal.close()">
      <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="card-body logs">
    <div class="pb-md-3 table-responsive" style="overflow: auto; height: 500px">
      <!-- {{recurringPaymentTxData | json}} -->
      <table class="table table-hover mb-0">
        <thead>
          <tr>
            <th class="pt-0 header_bolder text-left popup-headers" width="20%">TPN</th>
            <!-- <th class="pt-0 header_bolder text-left popup-headers" width="25%">Default Label</th> -->
            <th class="pt-0 header_bolder text-left popup-headers" width="25%">Serial Number</th>
            <th class="pt-0 header_bolder text-left popup-headers" width="20%">Merchant DBA</th>            
            <th class="pt-0 header_bolder text-left popup-headers" width="25%">Store DBA</th>            
            <th class="pt-0 header_bolder text-left popup-headers" width="20%">Created On</th>
            <th class="pt-0 header_bolder text-left popup-headers" width="20%">MCC Code</th>
            <th class="pt-0 header_bolder text-left popup-headers" width="20%">Device Model</th>
            <!-- <th class="pt-0 header_bolder text-left popup-headers" width="20%">Last Transact Date</th> -->
            <th class="pt-0 header_bolder text-left popup-headers" width="20%">Merchant Mobile</th>
            <th class="pt-0 header_bolder text-left popup-headers" width="20%">Merchant Email</th>
          </tr>
        </thead>                     
        <tbody>

          <tr *ngFor="let merchant of NTTPNList">
            <td class="text-left wht_space">
              <span placement="right" triggers="mouseenter:mouseleave">{{(merchant.tpn) || 'N/A'}}</span>
            </td>
            <!-- <td class="text-left wht_space">
              <span placement="right" triggers="mouseenter:mouseleave">{{(merchant.defaultLabel) || 'N/A'}}</span>
            </td> -->
            <td class="text-left wht_space">
              <span placement="right" triggers="mouseenter:mouseleave">{{(merchant.serialNumber) || 'N/A'}}</span>
            </td>
            <td class="text-left wht_space">
              <span placement="right" triggers="mouseenter:mouseleave">{{merchant.merchantdba || 'N/A'}}</span>
            </td>
            <td class="text-left wht_space">
              <span placement="right" triggers="mouseenter:mouseleave">{{merchant.storedba || 'N/A'}}</span>
            </td>
            <td class="text-left wht_space">
              <span placement="right" triggers="mouseenter:mouseleave">{{(merchant.createdOn | dateTimePipe) || 'NA'}}</span>
            </td>
            <td class="text-left wht_space">
              <span placement="right" triggers="mouseenter:mouseleave">{{merchant.merchantCategoryCode || 'NA'}}</span>
            </td>
            <td class="text-left wht_space">
              <span placement="right" triggers="mouseenter:mouseleave">{{merchant.deviceModelId || 'N/A'}}</span>
            </td>
            <!-- <td class="text-left wht_space">
              <span placement="right" triggers="mouseenter:mouseleave">{{(merchant.lastTxDate | dateTimePipe) || 'Not Transacted Yet'}}</span>
            </td> -->
            <td class="text-left wht_space">
              <span placement="right" triggers="mouseenter:mouseleave">{{merchant.phoneNumber || 'N/A'}}</span>
            </td>
            <td class="text-left wht_space">
              <span placement="right" triggers="mouseenter:mouseleave">{{merchant.email || 'N/A'}}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>